import React, { useState } from 'react'
import FormValidator from './FormValidators/FormValidator'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import Navbar from './Partial/Navbar';

export default function ResetPassword() {
    let navigate = useNavigate();
    let [data, setData] = useState({
        password: "",
        confirmPassword: ""
    })

    let [errorMessage, setErrorMessage] = useState({
        password: "",
    })

    let [show, setShow] = useState(false)
    let [message, setMessage] = useState("")

    function getInputData(e) {
        let { name, value } = e.target
        setMessage("")
        if (name !== "confirmPassword") {
            setErrorMessage((old) => {
                return {
                    ...old,
                    [name]: FormValidator(e)
                }
            })
        }

        setData((old) => {
            return {
                ...old,
                [name]: value
            }
        })

    }


    async function postData(e) {
        e.preventDefault();
        let error = Object.values(errorMessage).find((x) => x !== "");
        if (error)
            setShow(true);
        else if (data.password !== data.confirmPassword) {
            setShow(true)
            setErrorMessage((old) => {
                return {
                    ...old,
                    'password': "Password and Confirm Password Doesn't Matched"
                }
            })
        }
        else {
            let response = await fetch("/api/user/reset-password", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({ username: localStorage.getItem("password-reset-user"), password: data.password }),
            });

            response = await response.json();

            if (response.result === "Done") {
                toast.success("Password change successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                });
                localStorage.removeItem("password-reset-user")
                navigate("/login")
            } else {
                setShow(true);
                setMessage("Invalid Username or Password");
            }
        }
    }

    return (
        <>
            <Navbar />
            <div className="d-flex justify-content-center align-items-center background">
                <div className="card card-respon p-2 login-box mt-5">
                    <div className="card-body" >
                        <h2 className='text-center text-dark'><span className='text-info'>Mini</span>Store</h2>
                        <h6 className="card-title text-center border-bottom border-2 p-2">Login With Your Account</h6>
                        <form onSubmit={postData}>
                            <div className="row">
                                <div className="mt-3">
                                    <label className='text-info'>Password</label>
                                    <input type="password" name="password" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.password ? "border-danger" : "border-dark"} w-100`} placeholder='Enter Password' />
                                    {show && errorMessage.password ? <p className='text-danger'>{errorMessage.password}</p> : ""}
                                    {show && message ? <p className='text-danger'>{message}</p> : ""}
                                </div>
                                <div className="mt-3">
                                    <label className='text-info'>Confirm Password</label>
                                    <input type="password" name="confirmPassword" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.password ? "border-danger" : "border-dark"} w-100`} placeholder='Confirm Password' />
                                </div>
                            </div>
                            <div>
                                <button type="submit" className='btn btn-info border-2 w-100 mt-4'>Reset</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
